import uniq from 'lodash.uniq';

import { QueryBuilderCopy } from 'bones/components/molecules/QueryBuilder/types/schema';
import {
  INVALID_IRI_MATCHER,
  IRI_STARTS_WITH_MATCHER,
} from 'bones/constants/matchers';
import { INSTANCE_SPLIT_SYMBOL } from 'bones/utils/queryBuilder/constants';
import {
  INSTANCE_BACKTICKS_MATCHER,
  INSTANCE_COMMAS_MATCHER,
} from 'bones/utils/queryBuilder/matchers';

export const validateInstanceValue =
  (copy: QueryBuilderCopy) => (value: string) => {
    if (!value) {
      return { isValid: false, tooltip: '' };
    }

    const backticksMatch = value.match(INSTANCE_BACKTICKS_MATCHER);
    if (!backticksMatch) {
      return {
        isValid: false,
        tooltip: copy.error.instanceValueBackticks,
      };
    }

    const commaMatch = value.match(INSTANCE_COMMAS_MATCHER);
    if (!commaMatch) {
      return {
        isValid: false,
        tooltip: copy.error.instanceValueSplitCharacter,
      };
    }

    const iris = value
      .split(INSTANCE_SPLIT_SYMBOL)
      .filter(Boolean)
      .map((iri) => iri.replace(/`/g, ''));

    if (iris.some((iri) => !iri.match(IRI_STARTS_WITH_MATCHER))) {
      return {
        isValid: false,
        tooltip: copy.error.instanceValueStartsWith,
      };
    }

    if (iris.some((iri) => !iri.includes(':'))) {
      return {
        isValid: false,
        tooltip: copy.error.instanceValueSemicolon,
      };
    }

    let invalidChars: RegExpMatchArray | null = null;
    if (
      iris.some((iri) => {
        invalidChars = iri.match(INVALID_IRI_MATCHER);
        return invalidChars;
      })
    ) {
      return {
        isValid: false,
        tooltip: copy.error.instanceValueCharacters(uniq(invalidChars)),
      };
    }

    return { isValid: true, tooltip: '' };
  };
